import { render, staticRenderFns } from "./CreateService.vue?vue&type=template&id=3fa4e28a&scoped=true&"
import script from "./CreateService.vue?vue&type=script&lang=js&"
export * from "./CreateService.vue?vue&type=script&lang=js&"
import style0 from "./CreateService.vue?vue&type=style&index=0&id=3fa4e28a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4e28a",
  null
  
)

export default component.exports